export const reportDataNarcoticsConsolidated = {
  data: {
    rpp: '/COROTA/EstupefConsolidated',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/EstupefConsolidated',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },

  dataDownloadExcel: {
    rpp: '/COROTA/EstupefConsolidated',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/EstupefConsolidated',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};

export const reportDataNarcoticsDetailed = {
  data: {
    rpp: '/COROTA/EstupefDetailed',
    pts: 1,
    fr: true,
    dn: '',
    rp: '',
  },

  dataDownloadPDF: {
    rpp: '/COROTA/EstupefDetailed',
    pts: 0,
    fmt: 2,
    dn: '',
    rp: '',
  },

  dataDownloadExcel: {
    rpp: '/COROTA/EstupefDetailed',
    pts: 0,
    fmt: 3,
    dn: '',
    rp: '',
  },
  dataRenderReport: {
    rpp: '/COROTA/EstupefDetailed',
    pts: 0,
    z: 100,
    htmf: false,
    fmt: 2,
    dl: false,
    dn: '',
    rp: '',
  },
};

